/**
 * Dynamic Domain Utility
 * Derives current host and origins dynamically from runtime browser context.
 * Enables zero-code-change support for custom domains, staging environments,
 * workers.dev previews, and local development.
 */

export function getCurrentDomain(): string {
  if (typeof window !== 'undefined' && window.location?.host) {
    return window.location.host;
  }
  return 'localhost';
}

export function getCurrentOrigin(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

export function buildShortUrl(shortCode: string): string {
  const origin = getCurrentOrigin();
  return origin ? `${origin}/${shortCode}` : `/${shortCode}`;
}
